<template>
  <a-card nopad>
    <div class="booking-title d-flex justify-space-between">
      <span>Motorcoach</span>
    </div>

    <div v-if="motorList.length === 0" class="px-1">
      <span class="caption">(No transport added yet)</span>
    </div>

    <div v-else v-for="m in motorList" :key="m.id">
      <v-row align="start" class="px-1 caption">
        <v-col cols="3">
          <a-field :config="config.name" v-model="m.name" midtext />
        </v-col>
        <v-col cols="3">
          <elwrapper v-if="!m.confirmed" class="caption" midtext>(Not confirmed)</elwrapper>
          <elwrapper v-else :label="config.confirmation_num.label" widelabel>
            <div class="py-2">
              <div v-for="number in formatConfirm(m.confirm_number)" :key="number">{{ number }}</div>
            </div>
          </elwrapper>
        </v-col>

        <v-col cols="6">
          <v-row v-for="(d, index) in m.dates" :key="index" class="pa-0" style="max-height: 25px">
            <v-col cols="6" class="pa-0">
              <a-field v-if="d.on" :config="config.on" v-model="d.from" midtext />
              <elwrapper v-else label="On" midtext>
                {{ d.displayDate }}
              </elwrapper>
            </v-col>

            <v-col cols="6" class="pa-0" align-self="center">
              <a-truncate italic :text="'** ' + d.productNames" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider />
    </div>
  </a-card>
</template>

<script>
import infoUtils from "./utils";
import { BookingFields } from "@/config/fields/bookings";
export default {
  data() {
    return {
      config: BookingFields.motor_coach,
    };
  },
  computed: {
    motorList() {
      const transports = infoUtils.mergeConfirmedSuppliersForOverview(this.$store.getters, "TRANSPORT", "transport");
      return transports.filter((t) => t.product_type === "TRANS");
    },
  },
  methods: {
    formatConfirm(v) {
      if (!v) return "";
      if (typeof v === "string") return [v];
      return v;
    },
  },
};
</script>
